/* stylelint-disable selector-no-qualifying-type */
/* stylelint-disable max-nesting-depth */

/**
* @prop --uic-list-popover-max-height: The maximum height of the list.
* @prop --uic-list-popover-max-width: The maximum width of the list.
* @prop --uic-list-popover-width: The width of the list.
* @prop --uic-list-popover-min-width-offset: A number that gets subtracted from the popovers trigger width to calculate the final min-width of the popover.
* @prop --uic-dropdown-variant-content-max-width: The maximum width of the dropdown.
* @prop --uic-dropdown-variant-content-min-width: The minimum width of the dropdown.
*/

:host {
  @include form-control();
  box-sizing: border-box;
  display: inline-block;
  position: relative;

  .uic-dropdown {
    &__scroller {
      max-height: var(--uic-list-popover-max-height);
      max-width: var(--uic-list-popover-max-width);
      width: var(--uic-list-popover-width, auto);
    }

    &__button {
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      display: flex;
      font-family: var(--uic-font-family);
      font-weight: var(--uic-font-weight-semibold);
      gap: 8px;
      padding: 0 8px;
      text-align: left;
      width: 100%;
    }

    &__label {
      @include font(normal, normal);
      @include truncate();
      color: var(--uic-color-black);
      display: block;
    }

    &__value {
      display: inline-block;
      flex: 1;
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &--placeholder {
        color: var(--uic-color-grey3a50);
        font-weight: var(--uic-font-weight-normal);
      }
    }

    &__chevron {
      --uic-icon-width: var(--uic-icon-dimensions-default);
      --uic-icon-height: var(--uic-icon-dimensions-default);
      color: var(--uic-color-grey3);
      flex: 0 0 auto;
    }

    &__content {
      overflow: hidden;
    }
  }
}

:host(.uic-dropdown--open) {
  .uic-dropdown {
    &__button {
      box-shadow: none;
    }

    &__chevron {
      transform: rotate(180deg);
    }
  }
}

:host(.uic-dropdown--disabled) {
  pointer-events: none;

  .uic-dropdown__chevron {
    color: var(--uic-color-grey5);
  }
}

:host(.uic-dropdown--variant-content) {
  --uic-list-popover-min-width-offset: 16;

  max-width: var(--uic-dropdown-variant-content-max-width);
  min-width: var(--uic-dropdown-variant-content-min-width);

  .uic-dropdown {
    &__value {
      @include font(medium);
    }

    &__button {
      @include atom();
      height: var(--uic-dim-height);
      padding-right: 20px;

      &:active .uic-dropdown__chevron,
      &:hover .uic-dropdown__chevron,
      &:active .uic-dropdown__chevron {
        color: inherit;
      }
    }
  }
}

:host(.uic-dropdown--variant-header),
:host(.uic-dropdown--variant-header-icon-only),
:host(.uic-dropdown--variant-header-icon-button) {
  .uic-dropdown__scroller {
    width: var(--uic-list-popover-width, 200px);
  }

  .uic-dropdown__label {
    padding-bottom: 2px;
  }

  .uic-dropdown__value {
    font-size: var(--uic-font-size-normal);
    line-height: var(--uic-line-height-normal);
  }

  .uic-dropdown__button {
    background: var(--uic-color-white);
    border: 0;
    gap: var(--uic-dropdown-variant-header-button-gap);
    outline: 2px solid transparent;
    outline-offset: -2px;
    padding: var(--uic-dropdown-variant-header-button-padding);

    @include focus-visible-outline() {
      outline-color: var(--uic-color-blue2);
    }

    &:active .uic-dropdown__value,
    &:active .uic-dropdown__chevron,
    &:hover .uic-dropdown__value,
    &:hover .uic-dropdown__chevron {
      color: var(--uic-color-blue3);
    }

    &:disabled .uic-dropdown__value,
    &:disabled .uic-dropdown__chevron {
      color: var(--uic-color-grey5);
    }
  }
}

:host(.uic-dropdown--variant-header-icon-only) {
  .uic-dropdown__button {
    color: var(--uic-color-grey3);

    &:hover {
      color: var(--uic-color-blue3);
    }

    &:active {
      color: var(--uic-color-blue3);
    }

    &:disabled {
      color: var(--uic-color-grey3a50);
    }

    &:active .uic-dropdown__chevron,
    &:hover .uic-dropdown__chevron {
      color: inherit;
    }
  }

  .uic-dropdown__content {
    display: flex;
  }
}

:host(.uic-dropdown--variant-header-icon-button) {
  .uic-dropdown__button {
    @include atom();
    color: var(--uic-color-grey3);
    padding: var(--uic-dropdown-variant-header-button-padding);

    &:active .uic-dropdown__chevron,
    &:hover .uic-dropdown__chevron {
      color: inherit;
    }
  }

  .uic-dropdown__content {
    display: flex;
  }
}
